module.exports = __webpack_public_path__ + "img/lunbob.df9fa8a9.jpg";